<template>
  <button @click="click" :disabled="disabled" :class="['button-amo', type, loading && 'loading']">
    <i v-if="icon != ''" :class="`icon mdi mdi-${icon}`" />
    {{title}}
  </button>
</template>

<script>
export default {
  name: 'Button',
  data () {
    return {}
  },
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    }
  },
  methods: {
    click () {
      this.$emit('click')
    }
  }
}
</script>

<style lang="scss">
@import "./style.scss";
</style>
